export default __webpack_public_path__ + "static/media/57SS85.482f20a7.png";